module.exports = __webpack_public_path__ + "img/scheme-default.af4cf453.jpg";